import React from 'react';
import { BarChart3, LayoutGrid, PieChart } from 'lucide-react';
import type { AdvancedChartType } from './types';

type ChartTypeSelectorProps = {
  value: AdvancedChartType;
  onChange: (variant: AdvancedChartType) => void;
  disabled?: boolean;
};

const variants: { value: AdvancedChartType; label: string; icon: React.ReactNode }[] = [
  {
    value: 'bar-horizontal',
    label: 'Barras H',
    icon: <BarChart3 className="h-4 w-4 rotate-90" />,
  },
  {
    value: 'pie',
    label: 'Pie',
    icon: <PieChart className="h-4 w-4" />,
  },
  {
    value: 'bar-vertical',
    label: 'Barras V',
    icon: <BarChart3 className="h-4 w-4" />,
  },
  {
    value: 'treemap',
    label: 'Mapa',
    icon: <LayoutGrid className="h-4 w-4" />,
  },
];

export function ChartTypeSelector({ value, onChange, disabled }: ChartTypeSelectorProps) {
  return (
    <div className="inline-flex overflow-hidden rounded-lg border border-gray-200 bg-gray-50">
      {variants.map(variant => {
        const isActive = value === variant.value;
        return (
          <button
            key={variant.value}
            type="button"
            onClick={() => onChange(variant.value)}
            disabled={disabled}
            className={`flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium transition ${
              isActive
                ? 'bg-primary text-white'
                : 'text-gray-600 hover:bg-gray-100 hover:text-gray-900'
            } disabled:cursor-not-allowed disabled:opacity-50`}
            title={variant.label}
          >
            {variant.icon}
            <span className="hidden sm:inline">{variant.label}</span>
          </button>
        );
      })}
    </div>
  );
}
